import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import Form from '@appComponents/ReduxFormControls';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {StatusFilter} from '@utils/commonFilters/StatusFilter';

export function UserFiltersComponent({
    data: {
        roles = [],
    },
    filters: {
        Users = {},
    },
    loading = true,
    restoreFilterValues,
}) {
    return (
        <div className='users__filters filter__controls__container'>
            <SearchFilter
                loading={loading}
                filters={Users}
                restoreFilterValues={restoreFilterValues}
            />
            <Field
                component={Form.ReduxSelect}
                name='rolesId'
                placeholder='Role'
                options={roles}
                search
                loading={loading}
                multiple
                disabled={loading}
                setValue={restoreFilterValues(Users, 'rolesId')}
            />
            <StatusFilter
                loading={loading}
                filters={Users}
                restoreFilterValues={restoreFilterValues}
                statusType='IS_DISABLED'
                fieldName='isDisabled'
            />
        </div>
    );
}

UserFiltersComponent.propTypes = {
    data: PropTypes.shape({
        roles: PropTypes.array,
    }),
    filters: PropTypes.shape({
        Users: PropTypes.object,
    }),
    loading: PropTypes.bool,
    restoreFilterValues: PropTypes.func.isRequired,
};

const UserFilters = FiltersWrapper(UserFiltersComponent, {name: 'Users'});

export default UserFilters;
